import { render, staticRenderFns } from "./OnsiteSearch.vue?vue&type=template&id=0a6a0bf6&"
import script from "./OnsiteSearch.vue?vue&type=script&lang=ts&"
export * from "./OnsiteSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports